import { ExternalLink } from 'lucide-react'
import './RecordingDataLinks.css'

// Admin-only links to the raw rrweb + injected-script event data a task/recording is using. Both are
// served by the admin-gated `/api/admin-recording-data?recording_id=…&kind=rrweb|injected` endpoint.
// Render this only when the caller has an
// admin-resolved recording id — the endpoint itself is admin-gated, so non-admins can't use the links.
export default function RecordingDataLinks({ recordingId, label }: { recordingId: string; label?: string }) {
  return (
    <section className="recording-data-links" data-testid="recording-data-links">
      {label && <span className="recording-data-links__label">{label}</span>}
      <a
        href={`/api/admin-recording-data?recording_id=${encodeURIComponent(recordingId)}&kind=rrweb`}
        target="_blank"
        rel="noopener noreferrer"
        className="recording-data-links__link"
        data-testid="recording-data-rrweb-link"
        data-analytics-event="polish-rrweb-data-link"
      >
        <ExternalLink size={14} aria-hidden />
        rrweb data
      </a>
      <a
        href={`/api/admin-recording-data?recording_id=${encodeURIComponent(recordingId)}&kind=injected`}
        target="_blank"
        rel="noopener noreferrer"
        className="recording-data-links__link"
        data-testid="recording-data-injected-link"
        data-analytics-event="polish-injected-data-link"
      >
        <ExternalLink size={14} aria-hidden />
        injected data
      </a>
    </section>
  )
}
